import axios from '@/jslib/axios'

export const getAllOptions = data => {
  return axios({
    method: 'post',
    url: '/admin/quote/option',
    data
  })
}

export const getGlobalOptions = params => {
  return axios({
    method: 'get',
    url: '/admin/all/option',
    params
  })
}

export const getCustomerOptions = params => {
  return axios({
    method: 'get',
    url: '/admin/customer/list',
    params
  })
}

export const getCustomerOptionsPhone = params => {
  return axios({
    method: 'get',
    url: '/admin/customer/phone/list',
    params
  })
}

export const getCustomerOptionsEmail = params => {
  return axios({
    method: 'get',
    url: '/admin/customer/email/list',
    params
  })
}
export const getBanks =  params=>{
  return axios({
    method: 'get',
    url: '/admin/all/banks',
    params
  })
}

export const getNationalityOption = params => {
  return axios({
    method: 'get',
    url: '/admin/quote/kyc/nationality',
    params
  })
}
export const getProductInsurersPlanList = params => {
  return axios({
    method: 'get',
    url: '/admin/insurers/product/plan/list',
    params
  })
}
export const getGeneraliMortgagorList = params => {
  return axios({
    method: 'get',
    url: '/admin/generali/mortgagor/list',
    params
  })
}
